import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { CalendarClockIcon, FileBoxIcon } from "lucide-react";
import { useNegotiationProductHistories } from "../../hooks/useNegotiationProductsHistories";
import { ProductData } from "@/common/types/product.type";
import Badge from "@/common/components/Badge";
import { useState } from "react";
import NegotiationProductHistoriesLoadingState from "./ProductHistories/ProductHistoriesLoadingState";
import NegotiatingProductHistoryItem from "./ProductHistories/ProductHistoryItem";
import { twMerge } from "tailwind-merge";
import { CompanyData } from "@/features/privateCompanies/types/companies.type";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import ButtonLink from "@/common/components/ButtonLink";

interface NegotiationProductHistoriesModalProps {
  product: ProductData;
  clientCompany?: CompanyData;
  establishment?: EstablishmentCompanyData;
  negotiationProductId: string;
}

const NegotiationProductHistoriesModal = ({
  product,
  clientCompany,
  establishment,
  negotiationProductId,
}: NegotiationProductHistoriesModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  let {
    data: negotiationProductHistories,
    isPending: negotiationProductHistoriesIsPending,
  } = useNegotiationProductHistories({
    enabled: isOpen,
    negotiationProductId,
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={
          <Button
            variant="neutral"
            className="bg-white-800/40 text-black-600 disabled:bg-white-300 disabled:hover:bg-white-300 italic w-full text-sm"
            operationKlassToCheckPermission="Admin::Client::NegotiationProducts::HistoriesFilter"
          >
            Conferir histórico da negociação
            <CalendarClockIcon strokeWidth={1.5} size={18} />
          </Button>
        }
        title="Histórico de preços"
        body={
          <div
            className={twMerge(
              "flex flex-col gap-6 text-white-800 max-h-[520px] overflow-y-auto",
              negotiationProductHistoriesIsPending && "overflow-hidden",
            )}
          >
            <ButtonLink
              linkTo={`/products/${product.id}`}
              operationKlassToCheckPermission="Admin::Products::Show"
              hoverBackgroundSize="small"
            >
              <Badge
                Icon={FileBoxIcon}
                iconProps={{ size: 20, strokeWidth: 1.5 }}
                text={product.display_name}
                className="rounded-sm flex bg-neutral-op-8 w-fit flex-row-reverse !p-0 gap-0"
                overwriteClassName
                contentClassName="px-3 py-2"
              />
            </ButtonLink>

            <>
              {negotiationProductHistoriesIsPending && (
                <NegotiationProductHistoriesLoadingState />
              )}

              {!negotiationProductHistoriesIsPending &&
                negotiationProductHistories?.map(
                  (negotiationproductHistory) => (
                    <NegotiatingProductHistoryItem
                      key={negotiationproductHistory.id}
                      negotiationproductHistory={negotiationproductHistory}
                      clientCompany={clientCompany}
                      establishment={establishment}
                    />
                  ),
                )}
            </>
          </div>
        }
      />
    </>
  );
};

export default NegotiationProductHistoriesModal;
